/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DeviceTypeCertificateResponse,
    DeviceTypeCertificateResponseFromJSON,
    DeviceTypeCertificateResponseFromJSONTyped,
    DeviceTypeCertificateResponseToJSON,
} from './DeviceTypeCertificateResponse';

/**
 * 
 * @export
 * @interface DeviceTypeCertificatesResponse
 */
export interface DeviceTypeCertificatesResponse {
    /**
     * 
     * @type {Array<DeviceTypeCertificateResponse>}
     * @memberof DeviceTypeCertificatesResponse
     */
    elements: Array<DeviceTypeCertificateResponse>;
    /**
     * 
     * @type {number}
     * @memberof DeviceTypeCertificatesResponse
     */
    totalElementCount: number | null;
}

export function DeviceTypeCertificatesResponseFromJSON(json: any): DeviceTypeCertificatesResponse {
    return DeviceTypeCertificatesResponseFromJSONTyped(json, false);
}

export function DeviceTypeCertificatesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeviceTypeCertificatesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'elements': ((json['elements'] as Array<any>).map(DeviceTypeCertificateResponseFromJSON)),
        'totalElementCount': json['totalElementCount'],
    };
}

export function DeviceTypeCertificatesResponseToJSON(value?: DeviceTypeCertificatesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'elements': ((value.elements as Array<any>).map(DeviceTypeCertificateResponseToJSON)),
        'totalElementCount': value.totalElementCount,
    };
}

